const footer = {
  company: {
    payoff: 'Fondazione AIRC <br/> per la ricerca sul cancro ETS',
    description: 'Copyright ©2000-{currentYear} - Viale Isonzo 25, 20135 Milano',
  },
}

export default footer
